/**
 * Locale utility functions
 * Shared between frontend and backend
 */
/**
 * List of supported locales in the application
 */
export const SUPPORTED_LOCALES = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "es", name: "Español", flag: "🇪🇸" },
];
/**
 * Get supported locale codes
 */
export function getSupportedLocaleCodes() {
    return SUPPORTED_LOCALES.map((locale) => locale.code);
}
/**
 * Check if a locale code is supported
 */
export function isSupportedLocale(locale) {
    return getSupportedLocaleCodes().includes(locale);
}
/**
 * Get locale information by code
 */
export function getLocaleInfo(code) {
    return SUPPORTED_LOCALES.find((locale) => locale.code === code);
}
/**
 * Default locale code
 */
export const DEFAULT_LOCALE = "en";
